module.exports = __webpack_public_path__ + "img/star-2.3addcb35.svg";